/* eslint-disable no-undef */
import styles from './style.styl'
import { Component, createRef } from 'preact'
import { ArrowRight } from '../icons'
import { Regular } from '../text'

import michael from '../../assets/images/Wolf.png'
import james from '../../assets/images/Hilton.png'
import bidishaSinha from '../../assets/images/Sinha.png'
import paul from '../../assets/images/Wright.png'
import margaret from '../../assets/images/Ochieng.png'
import kate from '../../assets/images/Stanners.jpg'
import fura from '../../assets/images/Johannesdottir.jpg'
import maria from '../../assets/images/Giudice.jpg'
import jim from '../../assets/images/Prior.png'
import martina from '../../assets/images/Presnajderova.png'
import ajit from '../../assets/images/Singh.png'
import rachel from '../../assets/images/Kobetz.png'
import adrian from '../../assets/images/Talbot.png'
import sandeep from '../../assets/images/Datar.png'
import nikola from '../../assets/images/Watkinson.png'
import tom from '../../assets/images/Elvidge.png'

const ITEM_WIDTH_VW = 35
const ITEM_WIDTH_VW_M = 80
const TRANSITION_TIMEOUT = 300
const SPACE_BETWEEN = 15

const advisors = [ {
  imageSrc: michael,
  name: 'M<span class="alt">i</span>chael Wolff',
  company: 'Co-Founder of <br/>Wolff Olins',
  width: 24.5
},
{
  imageSrc: bidishaSinha,
  name: 'B<span class="alt">i</span>d<span class="alt">i</span>sha S<span class="alt">i</span>nha',
  company: 'Associate Director at <br/>Zaha Hadid Architecs',
  width: 20.7
},
{
  imageSrc: jim,
  name: 'J<span class="alt">i</span>m Pr<span class="alt">i</span>or',
  company: 'Former Global CEO at <br/>WPP agencies',
  width: 27
},
{
  imageSrc: martina,
  name: 'Mart<span class="alt">i</span>na Presnajderova',
  company: 'Pricing at <br/>Deel',
  width: 21,
  className: 'martina'
},
{
  imageSrc: ajit,
  name: 'Aj<span class="alt">i</span>t S<span class="alt">i</span>ngh',
  company: 'Investor, Partner at <br/>Artiman Ventures',
  width: 22.6
},
{
  imageSrc: rachel,
  name: 'Rachel Kobetz',
  company: 'Chief Design Officer at <br/>PayPal',
  width: 25.25
},
{
  imageSrc: james,
  name: 'James H<span class="alt">i</span>lton',
  company: 'Co-Founder of <br/>AKQA',
  width: 22.8
},
{
  imageSrc: margaret,
  name: 'Margaret Och<span class="alt">i</span>eng',
  company: 'Leadership Coach',
  width: 22.2
},
{
  imageSrc: adrian,
  name: 'Adr<span class="alt">i</span>an Talbot',
  company: 'Chief Financial Officer at <br/>Miroma Group',
  width: 28
},
{
  imageSrc: kate,
  name: 'Kate Stanners',
  company: 'Chairwoman & <br/> Global Chief Creative Officer at <br/>Saatchi & Saatchi',
  width: 23.6,
  className: 'kate'
},
{
  imageSrc: sandeep,
  name: 'Sandeep Datar',
  company: 'VP, UX and Design at <br/>Oracle',
  width: 26.7
},
{
  imageSrc: nikola,
  name: 'N<span class="alt">i</span>cola Watk<span class="alt">i</span>nson',
  company: 'Managing Director, <br/>International at <br/>TheCityUK',
  width: 19
},
{
  imageSrc: tom,
  name: 'Tom Elv<span class="alt">i</span>dge',
  company: 'Startup Advisor, <br/>Former General Manager at <br/>Uber UK & Ireland',
  width: 25,
  className: 'tom'
},
{
  imageSrc: maria,
  name: 'Mar<span class="alt">i</span>a G<span class="alt">i</span><span class="alt">u</span>d<span class="alt">i</span>ce',
  company: 'Founder of <br/>Hot Studio',
  width: 27
},
{
  imageSrc: paul,
  name: 'Pa<span class="alt">u</span>l Wr<span class="alt">i</span>ght',
  company: 'Head of International at <br/>Uber Advertising',
  width: 23.7
},
{
  imageSrc: fura,
  name: 'F<span class="alt">u</span>ra Johannesdott<span class="alt">i</span>r',
  company: 'Former Global Chief <br/>Creative Officer at <br/>Huge',
  width: 26.3
}].map(item => ({ ...item, width: item.width + SPACE_BETWEEN }))

const tripledAdvisors = [
  ...advisors,
  ...advisors,
  ...advisors
]

class Advisor extends Component {
  advisorRef = createRef()
  state = {
    isInView: false
  }

  intesectionCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.setState({ isInView: true })
      }
    })
  }

  componentDidMount () {
    const observer = new IntersectionObserver(this.intesectionCallback, {
      rootMargin: '0% 20% 100% 20%',
      threshold: 0
    })

    observer.observe(this.advisorRef.current)
  }

  render () {
    return (
      <div
        ref={this.advisorRef}
        className={styles.advisor}
        style={{ width: `${this.props.isMobile ? ITEM_WIDTH_VW_M : this.props.width || ITEM_WIDTH_VW}vw` }}
      >
        <div
          className={`${styles.advisorImg} ${this.props.className ? styles[this.props.className] : ''}`}
          style={{ backgroundImage: this.state.isInView ? `url(${this.props.imageSrc})` : undefined }}
        />
      </div>
    )
  }
}

const advWithCustomWidth = tripledAdvisors.map((adv, index) => ({ width: adv.width, index })).filter(adv => adv.width)

const Slider = ({
  currentSlideIndex,
  hasTransition,
  isMobile
}) => {
  const getWidthForCurrentIndex = () => {
    const customWidthBeforeIndex = advWithCustomWidth.filter(adv => adv.index < currentSlideIndex)
    const countCustomWidth = customWidthBeforeIndex.length
    const sumCustomWidth = customWidthBeforeIndex.reduce((prev, cur) => prev + cur.width, 0)
    const basicWidth = (isMobile ? ITEM_WIDTH_VW_M : ITEM_WIDTH_VW) * (currentSlideIndex - countCustomWidth)

    return isMobile ? ITEM_WIDTH_VW_M * currentSlideIndex : basicWidth + sumCustomWidth
  }
  return (
    <div className={styles.sliderBox}>
      <div className={styles.slider}>
        <div
          className={styles.sliderContent}
          style={{
            transform: `translateX(-${getWidthForCurrentIndex()}vw)`,
            transition: hasTransition ? `transform ${TRANSITION_TIMEOUT}ms ease` : ''
          }}
        >
          {tripledAdvisors.map(advisor => (
            <Advisor isMobile={isMobile} imageSrc={advisor.imageSrc} width={advisor.width} className={advisor.className} />
          ))}
        </div>
      </div>
    </div>
  )
}

const Name = ({ advisor, isExiting }) => (
  <div data-company={advisor.company} style={{ width: `${advisor.width || ITEM_WIDTH_VW}vw` }} className={isExiting ? styles.nameExiting : styles.name}>
    <p className={'upper'} dangerouslySetInnerHTML={{ __html: advisor.name }} />
    <p className={styles.company} dangerouslySetInnerHTML={{ __html: advisor.company }} />
  </div>
)

const Buttons = ({ nextSlide, prevSlide }) => (
  <div className={styles.buttons}>
    <button className={styles.button} onClick={prevSlide} aria-label='Go to previous slide'>
      <ArrowRight className={styles.reversed} width='100%' height='100%' />
    </button>
    <button className={styles.button} onClick={nextSlide} aria-label='Go to next slide'>
      <ArrowRight width='100%' height='100%' />
    </button>
  </div>
)

class Advisors extends Component {
  state = {
    currentSlideIndex: advisors.length,
    currentNameIndex: advisors.length,
    hasTransition: true,
    isNameExiting: false,
    isMobile: false
  }

  reset = () => {
    this.setState({
      currentSlideIndex: advisors.length,
      currentNameIndex: advisors.length,
      hasTransition: false
    })
  }

  scheduleReset = () =>
    setTimeout(
      this.reset,
      TRANSITION_TIMEOUT
    )

  scheduleNameChange = (nextNameIndex) =>
    setTimeout(() => {
      this.setState({
        currentNameIndex: nextNameIndex,
        isNameExiting: false
      })
    }, TRANSITION_TIMEOUT / 2)

  nextSlide = () => {
    this.setState(({ currentSlideIndex }) => {
      const nextSlideIndex = currentSlideIndex + 1
      if (nextSlideIndex === advisors.length * 2) {
        this.scheduleReset()
      }
      this.scheduleNameChange(nextSlideIndex)
      return {
        currentSlideIndex: nextSlideIndex,
        hasTransition: true,
        isNameExiting: true
      }
    })
  }

  prevSlide = () => {
    this.setState(({ currentSlideIndex }) => {
      const prevSlideIndex = currentSlideIndex - 1
      if (prevSlideIndex === 0) {
        this.scheduleReset()
      }
      this.scheduleNameChange(
        prevSlideIndex >= 0
          ? prevSlideIndex
          : advisors.length + prevSlideIndex
      )
      return {
        currentSlideIndex: prevSlideIndex,
        hasTransition: true,
        isNameExiting: true
      }
    })
  }

  render () {
    const {
      currentSlideIndex,
      hasTransition,
      currentNameIndex,
      isNameExiting,
      isMobile
    } = this.state
    const firstAdvisor = tripledAdvisors[currentNameIndex]
    const secondAdvisor = tripledAdvisors[currentNameIndex + 1]
    return (
      <div className={styles.advisors} id={'teachers'}>
        <Regular>Your teachers:</Regular>
        <Slider
          currentSlideIndex={currentSlideIndex}
          hasTransition={hasTransition}
          isMobile={isMobile}
        />
        <Regular as='div' className={styles.bottom}>
          <Name advisor={firstAdvisor} isExiting={isNameExiting} />
          <Name advisor={secondAdvisor} isExiting={isNameExiting} />
          <Buttons
            nextSlide={this.nextSlide}
            prevSlide={this.prevSlide}
          />
        </Regular>
      </div>
    )
  }

  checkIfMobile = () => {
    this.setState({
      isMobile: window.innerWidth <= 600
    })
  }

  componentDidMount () {
    this.checkIfMobile()
    window.addEventListener('resize', this.checkIfMobile)
  }
  componentWillUnmount () {
    window.removeEventListener('resize', this.checkIfMobile)
  }
}

export default Advisors



// WEBPACK FOOTER //
// ./components/advisors/index.js